<template>
  <div>
    <el-dialog
      top="5vh"
      v-loading="loading"
      :title="'缴款列表，项目：'+house_name"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose">
      <div style="height: 75vh;overflow-y: auto;">
        <el-button @click="selects(1)">查询</el-button>
<!--        <el-button @click="del(1)">删除</el-button>
        <el-button @click="del(2)">全部删除</el-button>-->
        <!-- 查询条件 -->
        <div style="width: 99%;">
          <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
            <el-descriptions-item  label="计费周期">
              <el-date-picker v-model="data.startDate" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
              <span style="margin-left: 1px;margin-right: 1px;">至</span>
              <el-date-picker v-model="data.endDate" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="收费项">
              <el-select v-model="data.select_charge_id" @change="chargeItem_names" style="width: 100%" clearable size="mini" placeholder="收费项">
                <el-option
                  v-for="item in chargeitem"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-descriptions-item>

          </el-descriptions>
        </div>

        <div style="width: 99%; margin-top: 10px;">
          <span>选中金额：<span style="color: red;">{{money_val}}</span>元</span>
          <span style="margin-left: 15px;">总金费：<span style="color: red;">{{money}}</span>元</span>
          <span style="margin-left: 15px;">缴款金额：<span style="color: red;">{{money1}}</span>元</span>
          <span style="margin-left: 15px;">减免金额：<span style="color: red;">{{money3}}</span>元</span>
          <span style="margin-left: 15px;">操作后欠费：<span style="color: red;">{{money2}}</span>元</span>
          <span style="margin-left: 15px;color: red;" v-if="loading_dade==2">加载中...</span>
          <div>
            <el-table ref="multipleTable" height="50vh" :data="orderData" border style="width: 100%" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55" > </el-table-column>
              <el-table-column prop="name" label="业户" width="100"></el-table-column>
              <el-table-column prop="h_name_date" label="房产" width="350"></el-table-column>
              <el-table-column prop="chargeItem_name" label="收费标准" width="180"></el-table-column>
              <el-table-column label="计费周期" width="170">
                <template slot-scope="scope">{{scope.row.startDate}}-{{scope.row.endDate}}</template>
              </el-table-column>
              <el-table-column prop="xsc_Price" label="单价" width="70"></el-table-column>
              <el-table-column label="数量" width="70">
                <template slot-scope="scope">{{scope.row.xsc_Amount}}</template>
              </el-table-column>
              <el-table-column label="房产面积" width="70">
                <template slot-scope="scope">{{scope.row.charging}}</template>
              </el-table-column>
              <el-table-column label="欠费金额" width="80">
                <template slot-scope="scope">{{scope.row.primaryCharge}}</template>
              </el-table-column>
              <el-table-column label="收款金额" width="100">
                <template slot-scope="scope">
                  <el-input size="mini" @change='delayCharge(orderData[scope.$index],scope.$index)' v-model="orderData[scope.$index].paymentCharge"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="减免金额" width="100">
                <template slot-scope="scope">{{scope.row.discountCharge}}</template>
              </el-table-column>

              <el-table-column label="操作后欠费" width="100">
                <template slot-scope="scope">{{scope.row.money}}</template>
              </el-table-column>
              <el-table-column label="应收金额" width="100">
                <template slot-scope="scope">{{scope.row.moneys}}</template>
              </el-table-column>
              <el-table-column label="已缴金额" width="100">
                <template slot-scope="scope">{{scope.row.PaidChargeSum}}</template>
              </el-table-column>
              <el-table-column label="已减免金额" width="100">
                <template slot-scope="scope">{{scope.row.discount}}</template>
              </el-table-column>
              <!-- <el-table-column label="收款后欠费" width="100">
                 <template slot-scope="scope">{{scope.row.money}}</template>
               </el-table-column> -->
              <el-table-column prop="date" label="添加时间" width="150"></el-table-column>
            </el-table>
          </div>
          <div class="pages">
            <el-pagination @size-change="selects_size"
                           @current-change="handleCurrentChange"
                           :current-page="page"
                           :page-sizes="[20,50,100,200,300,400,500]"
                           :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import ViewFlow from "../../Common/ViewFlow.vue";

  export default {
    // 接受父组件的值
    props: {

    },
    watch:{

    },
    data () {
      return {
        select:{
          pay:'',
          house:'',
          name:'',
          date:'',
          chargeitem_id:[],
        },
        dialogVisible:false,
        loading:false,
        tableData: [],
        loadingModal: false,
        fileList:[],
        modal:false,
        url:'',
        task_id:'',
        type:false,
        orderData:[],
        page:1,
        pageSize:20,
        total:0,
        chargeitem:[],
        chargeitems:[],
        order:[],
        money:0,
        money_val:0,
        money1:0,
        money2:0,
        money3:0,
        red_id:'',
        pid:'',
        house:'',
        house_name:'',
        red_house:'',
        loading_dade:1,
        data:{
          moneyType:'单价,用量,金额联动',
          select_charge_id:'',
          select_reduce_type:'',
          reduce_type:'',
          chargeItem_name_id:'',
          chargeItem_name_ids:'',
          startDate:'',
          endDate:'',
          money:'',
          money1:'',
          url:'',
        }
      }
    },
    mounted(){
      //加载收费大类（费项）
      this.$myhttp
        .get("admin/common/getChargeitem", {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          this.chargeitem = backdata.data.data;
        });
    },
    //事件
    methods: {
      getInvo(house,pid,red_id,red_house){
        console.log('house',house);
        console.log('pid',pid);
        this.dialogVisible = true;
        this.pid = pid;
        // this.select.pay = '';
        this.house = house;
        this.red_id = red_id;
        this.select.house = red_house;
        this.red_house= red_house;
        this.selects_s();
        this.housePid();
      },
      selects_s(){
        this.money = "加载中";
        this.total = 1;
        if(this.type != 1){
          this.page = 1;
        }
        this.type = 1;
        this.selects(this.page);
        /*let data = {'select':this.select,'date':this.date,'xsc_bill_no':this.xsc_bill_no,'type':1,'page':this.page,'pid':this.pid,'pageSize':this.pageSize}
        //分页
        this.$myhttp.post('admin/OrderList/paid_count',data,{
          'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.total = backdata.data.count;
        },err=>{
          this.$Message.error('请求异常!');
        });
        //金额
        this.$myhttp.post('admin/OrderList/paid_money',data,{
          'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.money = backdata.data.money;
        },err=>{
          this.$Message.error('请求异常!');
        });*/
      },
      handleClose(done) {
        //调用父组件方法
        this.$parent.selects(1);
        done();
      },
      //查询当前项目
      housePid(){
        this.$myhttp.get('admin/common/house_pid?pid='+this.pid+"&house="+encodeURIComponent(this.select.house),{
          'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data.code == 200){
            this.house_name = backdata.data.data.name;
            this.pid = backdata.data.data.id;
          }
        });
      },
      //导入
      excelAdd(){
        if(this.pid == ''){
          this.$Message.error('点击左边树选择项目');
          return false;
        }
        this.modal = true;
      },
      //超过一个文件
      handleExceed(files, fileList) {
        // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        this.$message.warning(`一次只允许上传1个文件`);
      },
      //删除
      beforeRemove(file, fileList) {
        this.tableData = [];
        this.total = 0;
        this.money = 0;
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
      //限制大小
      beforeAvatarUpload(file){
        const isLt7M = file.size / 1024 / 1024 < 15;
        if (!isLt7M) {
          this.$message.error('上传文件大小不能超过 8MB!');
        }
        return isLt7M;
      },
      //上传成功返回
      handleAvatarSuccess(res, file){
        this.data.url = file.response[0];
        //console.log(369369);
        this.type=2;
      },
      //导入
      addexcels(){
        ERP.showLoading()
        let data = {'data':this.data,'house':this.house,'pid':this.pid}
        this.$myhttp.post('admin/OrderRedFlushFlow/addexcel',data,{
          'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          ERP.hideLoading()
          this.$Message.success('操作成功!');
          this.selects(this.page);
        },err=>{
          ERP.hideLoading()
          this.$Message.error('请求异常!');
        });
      },
      //删除
      del(e){
        if(this.pid == ''){
          //this.$Message.error('点击左边树选择项目');
          this.$confirm('点击左边树选择项目', '提示', {
            confirmButtonText: '关闭',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => { })
          return false;
        }
        if(this.red_id == ''){
          //this.$Message.error('请点击红冲记录');
          this.$confirm('请点击红冲记录', '提示', {
            confirmButtonText: '关闭',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => { })
          return false;
        }
        this.$confirm('确定操作吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ERP.showLoading()
          let data = {'data':this.data,'house':this.house,'pid':this.pid,'red_id':this.red_id,'type':e,'order':this.order}
          this.$myhttp.post('admin/OrderRedFlushFlow/delOrder',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            ERP.hideLoading()
            this.$Message.success('操作成功!');
            this.selects(this.page);
            //调用父组件方法
            this.$parent.selects(1);
          },err=>{
            ERP.hideLoading()
            this.$Message.error('请求异常!');
          });
        })
      },
      handleSelect(){

      },
      //远程搜索方式
      querySearchAsync(query, cb) {
        if (query !== '') {
          this.loading_dade = 2;
          this.$myhttp.get('admin/common/house_name?house_name='+encodeURIComponent(query),{
            'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.loading_dade = 1;
            let selectList = backdata.data.data;
            let value = [];
            selectList.map(req=>{
              value.push({'value':req.house})
            })
            cb(value)
          });
        }
      },

      //费项
      chargeItem_names(){
        let data = {'data':this.data,'pid':this.pid}
        this.$myhttp.post('admin/OrderAdjust/chargeItem_names',data,{
          'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{
          this.chargeitems = backdata.data.data;
        },err=>{
          this.$Message.error('请求异常!');
        });
      },
      //缴款
      delayCharge(val){
        let data = {'data':val,'type':2,'select':this.data};
        this.$myhttp.post('admin/OrderRedFlushFlow/updateOrder',data,{
          'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{
          if(backdata.data.code == 201){
            this.$confirm(''+backdata.data.message, '提示', {
              confirmButtonText: '关闭',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.selects(this.page);
            })
            // this.$Message.error(backdata.data.message);
          }else{
            this.$Message.success(backdata.data.message);
            // this.$Message.success('操作成功!');
            this.selects(this.page);
          }
        },err=>{
          this.$Message.error('请求异常!');
        });
      },
      handleSelectionChange(val){
        this.order = val;
        let money = 0;
        this.order.map(req=>{
          money = Number(money) + Number(req.paymentCharge);
        })
        this.money_val = money.toFixed(2);
      },
      handleCurrentChange(e){
        this.page = e;//第几页
        this.selects(this.page);
      },
      selects_size(e){
        this.pageSize = e;
        this.selects(this.page);
      },
      // 查询
      selects(e){
        if(this.pid == ''){
          this.$Message.error('点击左边树选择项目');
          return false;
        }
        if(e){
          this.page = e;
        }
        console.log('red_id',this.red_id);
        this.chargeitems = [];
        this.data.chargeItem_name_id = '';
        this.data.chargeItem_name_ids = '';
        this.loading_dade = 2;
        let data = {'data':this.data,'house':this.house,'page':this.page,'pid':this.pid,'red_id':this.red_id,'is_flow':1,'pageSize':this.pageSize}
        this.$myhttp.post('admin/OrderRedFlushFlow/after_paid_list',data,{
          'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.orderData = backdata.data.data;
          this.total = backdata.data.count;
          this.money = backdata.data.money;
          this.money1 = backdata.data.money1;
          this.money2 = backdata.data.money2;
          this.money3 = backdata.data.money3;
          this.chargeitem = backdata.data.charge;
          this.loading_dade = 1;
        },err=>{
          this.loading_dade = 1;
          this.$Message.error('请求异常!');
        });
      },
      //点击树
      nodeClick(data){
        this.pid = data.tree[0].pindex_id;
        let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
        this.house=tree_str;
        this.selects(this.page);
      },
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/order/afterPaidFlow.vue